import { Tab, Tabs as MuiTabs, Theme, Stack } from '@mui/material';

import { FC, SyntheticEvent } from 'react';
import { createUseStyles } from 'react-jss';
import { TabPanel as TabPanelType } from './helpers';
import Icon from '../icon';

interface Props {
  panels: TabPanelType[];
  tabIndex: number;
  onTabChange?: (_event: SyntheticEvent, tabIndex: number) => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  tabBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tab: {
    '&.titleCase': {
      textTransform: 'none !important', // Important to override MUI default
    },
  },
}));

const a11yProps = (index: string) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

const TabBar: FC<Props> = ({ panels, tabIndex, onTabChange }) => {
  const styles = useStyles();

  return (
    <MuiTabs
      value={tabIndex}
      onChange={onTabChange}
      textColor="inherit"
      variant="fullWidth"
      className={styles.tabBar}
    >
      {panels.map(({ label, path, disabled, icon }) => (
        <Tab
          key={path}
          label={
            icon ? (
              <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={0.5}>
                <Icon name={icon} size="small" /> {label}
              </Stack>
            ) : (
              label
            )
          }
          {...a11yProps(path)}
          disabled={disabled}
          className={styles.tab}
        />
      ))}
    </MuiTabs>
  );
};

export default TabBar;
